import React from 'react';

function ForumPage() {
    return (
        <>
            <h2>Forum</h2>
            <p>Coming Soon</p>
         </>
    );
}

export default ForumPage;